import {svgIconWrapper} from '../svg-icon-wrapper';

import OpenAIOutlineAI from './openai-outline-ai-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <OpenAIOutlineAI {...props} />;
}

SvgComponent.iconName = 'openAIOutlineAI';

export const OpenAIOutlineAIIcon = svgIconWrapper(SvgComponent);
